module.exports = __webpack_public_path__ + "img/img-8963e2.png";